import { faCancel, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useContext } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PayPalPopUp } from "../components/paypalpopup";
import AuthContext from "../utils/Auth";
import "./planessocios.css";
import { useTranslation } from "react-i18next";
import useGrantAccess from "../hooks/useAccess";
//console.log("En qué estado estamos?", REACT_APP_MODE);

export default function Planessocios() {
  const { currentUser } = useContext(AuthContext);
  const { verifyMembership } = useGrantAccess(currentUser);
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const planPro = [
    {
      title: `${t("Suscriptions.Sucriptions_Pro.TrainingTools")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.FromTo")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.Transmitions")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.ShareIn")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.PrivateAndPublic")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.CreateHL")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.ShareWithCoach")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.Tagged_users")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.NoAdsVideos")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.Download")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Sucriptions_Pro.Storage2")}`,
      icon: faCheckCircle,
      include: true,
    },
    //{
    //  title: `${t("Suscriptions.Sucriptions_Pro.MarkBelong")}`,
    //  icon: faCancel,
    //  include: false,
    //},
  ];
  const planFree = [
    {
      title: `${t("Suscriptions.Sucriptions_Pro.TrainingTools")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.FromTo")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscription_free.Transmitions")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscription_free.ShareIn")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscription_free.PrivateAndPublic")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.CreateHL")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.ShareWithCoach")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.Tagged_users")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.NoAdsVideos")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.Download")}`,
      icon: faCancel,
      include: false,
    },
    {
      title: `${t("Suscriptions.Suscription_free.Storage2")}`,
      icon: faCheckCircle,
      include: true,
    },
  ];
  const planSuperPro = [
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.TrainingTools")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.FromTo")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.Transmitions")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.ShareIn")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.PrivateAndPublic")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.CreateHL")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.ShareWithCoach")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.Tagged_users")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.NoAdsVideos")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.Download")}`,
      icon: faCheckCircle,
      include: true,
    },
    {
      title: `${t("Suscriptions.Suscriptions_SuperPro.Storage2")}`,
      icon: faCheckCircle,
      include: true,
    },
    //{
    //  title: `${t("Suscriptions.Suscriptions_SuperPro.MarkBelong")}`,
    //  icon: faCheckCircle,
    //  include: true,
    //},
  ];

  return (
    <div className="container">
      <div className="mt-5 row">
        <div className="col-md-4">
          <div className="text-white card card-pricing card-raised container-plan-pro">
            <div className="bg-red-800 rounded-lg card-body ">
              <div
                style={{
                  height: "80px",
                }}
              >
                <span className="absolute rounded-full shadow-lg right-1 top-6 laptop:top-4 laptop:right-1">
                  <img
                    src="/img/logo-fentech.png"
                    alt="fentech"
                    className="rounded-full w-[3rem] h-[3rem] laptop:w-[4rem] laptop:h-[4rem] object-cover"
                  />
                </span>

                <h5 className="card-category text-titulo-pro">
                  {t("Suscriptions.suscriptionSuperPro")}
                </h5>
                <div className="flex flex-row items-center justify-center">
                  <small className="text-base font-medium text-white">
                    USD
                  </small>
                  <small className="mx-1 text-xl font-semibold text-white">
                    9,50
                  </small>
                  <small className="text-base font-medium text-white">
                    / {t("Suscriptions.month")}
                  </small>
                  <small className="mx-2 font-bold text-white"> O </small>
                  <small className="text-base font-medium text-white">
                    USD
                  </small>
                  <small className="mx-1 text-xl font-semibold text-white">
                    69,90
                  </small>
                  <small className="text-base font-medium text-white">
                    / {t("Suscriptions.anual")}
                  </small>
                </div>
              </div>
              <div className="mt-3 border-white row border-bottom"></div>
              {planSuperPro.map((item, index) => {
                const isLastItem = index === planPro.length - 1;
                return (
                  <React.Fragment key={index + item.title}>
                    <div className="flex flex-row items-center justify-start my-3">
                      <div className="flex items-center justify-center mr-4 ">
                        <FontAwesomeIcon
                          className={
                            "icono-planes-socios-ok " +
                            (item.include ? "ok-gratis" : "cancel")
                          }
                          icon={item.icon}
                        />
                      </div>
                      <div>
                        <p
                          className="text-planes-socios"
                          style={{
                            color: "white",
                          }}
                        >
                          {item.title}
                        </p>
                      </div>
                    </div>
                    {!isLastItem && (
                      <div className="mt-3 border-white row border-bottom"></div>
                    )}
                  </React.Fragment>
                );
              })}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {currentUser ? (
                  <div>
                    {verifyMembership() !== "FREE" ? (
                      <button
                        className="px-6 py-4 font-semibold text-black rounded-lg shadow-md bg-slate-300 hover:bg-red-600 hover:text-white"
                        disabled
                      >
                        {t("Suscriptions.suscribeOnready")}
                      </button>
                    ) : (
                      <>
                        <button
                          className="px-6 py-4 font-semibold text-black rounded-lg shadow-md bg-slate-300 hover:bg-red-600 hover:text-white"
                          onClick={() => {
                            navigate("/gatewayPayments", {
                              state: {
                                subscriptionName:
                                  "Suscripción Super-Pro(Mensual)",
                                subscriptionType: "SuperPro",
                                subscriptionAmount: 9500,
                                subscriptionFrequency: "monthly",
                              },
                            });
                          }}
                        >
                          {t("Suscriptions.suscribeMonthly")}
                        </button>
                        <p className="text-lg font-semibold text-center cursor-pointer hover:text-red-300">
                          O
                        </p>
                        <button
                          className="px-6 py-4 font-semibold text-black rounded-lg shadow-md bg-slate-300 hover:bg-red-600 hover:text-white"
                          onClick={() => {
                            navigate("/gatewayPayments", {
                              state: {
                                subscriptionName:
                                  "Suscripción Super-Pro(Anual)",
                                subscriptionType: "SuperPro",
                                subscriptionAmount: 69600,
                                subscriptionFrequency: "annual",
                              },
                            });
                          }}
                        >
                          {t("Suscriptions.suscribeAnnual")}
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      onClick={() => {
                        navigate("/login");
                      }}
                      className="text-lg font-semibold text-center cursor-pointer hover:text-red-300"
                    >
                      {t("SuscriptionClub.NeedsLogin")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="text-white card card-pricing card-raised container-plan-pro">
            <div className="bg-red-800 rounded-lg card-body">
              <div
                style={{
                  height: "80px",
                }}
              >
                <h5 className="card-category text-titulo-pro">
                  {t("Suscriptions.suscripcionPro")}
                </h5>
                <h5 className="card-category text-titulo-pro"></h5>
                <div className="flex flex-row items-center justify-center">
                  <small className="text-base font-medium text-white">
                    USD
                  </small>
                  <small className="mx-1 text-xl font-semibold text-white">
                    2,9
                  </small>
                  <small className="text-base font-medium text-white">
                    /{t("Suscriptions.month")}
                  </small>
                </div>
              </div>
              <div className="mt-3 border-white row border-bottom"></div>
              {planPro.map((item, index) => {
                const isLastItem = index === planPro.length - 1;
                return (
                  <>
                    <div
                      key={index}
                      className="flex flex-row items-center justify-start my-3"
                    >
                      <div className="flex items-center justify-center mr-4 ">
                        <FontAwesomeIcon
                          className={
                            "icono-planes-socios-ok " +
                            (item.include ? "ok-gratis" : "cancel")
                          }
                          icon={item.icon}
                        />
                      </div>
                      <div>
                        <p
                          className="text-planes-socios"
                          style={{
                            color: "white",
                          }}
                        >
                          {item.title}
                        </p>
                      </div>
                    </div>
                    {!isLastItem && (
                      <div className="mt-3 border-white row border-bottom"></div>
                    )}
                  </>
                );
              })}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
                className="mt-3"
              >
                {currentUser ? (
                  <div>
                    {verifyMembership() !== "FREE" ? (
                      <button
                        className="px-6 py-4 font-semibold text-black rounded-lg shadow-md bg-slate-300 hover:bg-red-600 hover:text-white"
                        disabled
                      >
                        {t("Suscriptions.suscribeOnready")}
                      </button>
                    ) : (
                      <button
                        className="px-6 py-4 font-semibold text-black rounded-lg shadow-md bg-slate-300 hover:bg-red-600 hover:text-white"
                        onClick={() => {
                          navigate("/gatewayPayments", {
                            state: {
                              subscriptionName: "Suscripción pro",
                              subscriptionType: "Pro",
                              subscriptionAmount: 2900,
                              subscriptionFrequency: "monthly",
                            },
                          });
                        }}
                      >
                        {t("Suscriptions.suscribeMonthly")}
                      </button>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      onClick={() => {
                        navigate("/login");
                      }}
                      className="text-lg font-semibold text-center cursor-pointer hover:text-red-300"
                    >
                      {t("SuscriptionClub.NeedsLogin")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="text-black card card-pricing card-raised card-plain">
            <div className="card-body ">
              <div>
                <div
                  style={{
                    height: "80px",
                  }}
                >
                  <h5 className="card-category text-titulo-gratis">
                    {t("Suscriptions.suscriptionFree")}
                  </h5>
                  <div className="flex flex-row items-center justify-center">
                    <small className="text-base font-medium text-black">
                      USD
                    </small>
                    <small className="text-xl font-semibold text-black mx-">
                      0,00
                    </small>
                    <small className="text-base font-medium text-black">
                      /{t("Suscriptions.month")}
                    </small>
                  </div>
                </div>
                <div className="mt-3 row border-bottom border-top border-gray"></div>
                {planFree.map((item, index) => {
                  const isLastItem = index === planFree.length - 1;
                  return (
                    <React.Fragment key={index + item.title + Math.random()}>
                      <div
                        key={index}
                        className="flex flex-row items-center justify-start my-3"
                      >
                        <div className="flex items-center justify-center mr-4 ">
                          <FontAwesomeIcon
                            className={
                              "icono-planes-socios-" +
                              (item.include ? "ok-gratis" : "cancel")
                            }
                            icon={item.icon}
                          />
                        </div>
                        <div>
                          <p
                            className="text-planes-socios"
                            style={{
                              color: "black",
                            }}
                          >
                            {item.title}
                          </p>
                        </div>
                      </div>
                      {!isLastItem && (
                        <div className="mt-3 border-gray row border-bottom"></div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
